module.exports = __webpack_public_path__ + "static/img/news3_7.34db1fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/open/panels/news/img/detail/news3_7.png
// module id = ++Yw
// module chunks = 0